<template>
<div class="chapter">
<div class="inner_page">
<p class="part-number"><a href="#/Text/Contents#p1"><span class="blue">PART ONE</span></a></p>
<p class="part-title">Watchers of Water</p>
<p class="extract-space-after"><span class="ital">‘Only what changes can remain.’</span></p>
<p class="extract-source">Wei Wulong, ‘The Path of Tea’</p>
<p class="extract-source">7th century of Old Qian time</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Part1.vue?1e327dce